import { FormControlBase } from '../models/form-control-base';
import { FormControlTypeEnum } from '../models/form-control-type.enum';

export class FormControlCheckBox extends FormControlBase<boolean> {
	public controlType = FormControlTypeEnum.CheckBox;
}
